// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3Jrn0"};